import {Injectable, Injector} from "@angular/core";
import {Http} from "@angular/http";
import {SERVICE_URLS} from "@tci/common";
import * as lodash from "lodash";
import {Observable} from "rxjs";


@Injectable()
export class TciContribRequestService {
    private static instance: TciContribRequestService;
    private contributions = [];
    private contributionsObservable: Observable<any>;

    public static getInstance(http: Http, injector: Injector): TciContribRequestService {
        if (!TciContribRequestService.instance) {
            TciContribRequestService.instance = new TciContribRequestService(http, injector);
        }
        return TciContribRequestService.instance;
    }

    constructor(private http: Http, private injector: Injector) {
        this.contributionsObservable = this.http.get(SERVICE_URLS.CONTRIBUTIONS)
            .map((response) => {
                this.contributions = <any>response.json();
                this.sortContributions();
                return lodash.cloneDeep(this.contributions);
            })
            .share();
    }

    getContributions(refresh?: boolean): Observable<any> {
        if (!refresh && this.contributions.length > 0) {
            return Observable.create(observer => {
                observer.next(lodash.cloneDeep(this.contributions));
            });
        } else {
            return this.contributionsObservable;
        }
    }

    getContributionsInventory(refresh?: boolean): Observable<any> {
        return Observable.create(observer => {
            if (!refresh && this.contributions.length > 0) {
                observer.next(lodash.cloneDeep(this.contributions));
                observer.complete();
            } else {
                this.getContributions().subscribe((data) => {
                    observer.next(data);
                    observer.complete();
                });
            }
        });
    }

    private sortContributions() {
        this.contributions = lodash.sortBy(this.contributions, [o => lodash.get(o, "display.category"), "title"]);
    }

    clearCache() {
        this.contributions = [];
    }
}
